import {useDispatch, useSelector} from 'react-redux'

import {postBroadcastChannelMessage} from '@vio/core/src/_web/utils/broadcastChannel'
import {reloadPage} from '@vio/core/src/_web/utils/browser/navigateTo'
import {getCookie, removeCookie} from '@vio/core/src/_web/utils/cookies'
import {
  removeCognitoUserTierFromCookie,
  setLastLoginUrl
} from '@vio/core/src/auth/business/persistData'
import {getConnection, selectUser} from '@vio/core/src/auth/modules/selectors'
import {logOut} from '@vio/core/src/auth/modules/slice'
import {signOutService} from '@vio/core/src/auth/services'
import {AuthBroadcastChannelMessages} from '@vio/core/src/auth/types/Auth'
import {OFFER_MODE_COOKIE} from '@vio/core/src/profile/constants'

export const useLogOut = () => {
  const dispatch = useDispatch()
  const user = useSelector(selectUser)

  return async () => {
    const hasOfferModeOverride = Boolean(getCookie(OFFER_MODE_COOKIE))
    if (hasOfferModeOverride) removeCookie(OFFER_MODE_COOKIE, {path: '/'})

    setLastLoginUrl(window.location.href)
    removeCognitoUserTierFromCookie()

    dispatch(logOut())

    await signOutService()

    postBroadcastChannelMessage(
      'auth',
      AuthBroadcastChannelMessages.AuthStateChanged
    )

    // Provider sign-ins already reload through the Cognito logout redirect, which a reload here would cancel
    if (hasOfferModeOverride && !getConnection(user)) reloadPage()
  }
}
